import ParadiseIncheonMockup from './images/list/paradise-incheon.webp';
import DMMockup from './images/list/dear-monday.webp';
import ParadiseBusanMockup from './images/list/paradise-busan.webp';
import Ttokttok365Mockup from './images/list/ttokttok365.webp';
import HyundaiMockup from './images/list/hyundai.webp';
import VroongMockup from './images/list/vroong.webp';
import ArtiketMockup from './images/list/artiket.webp';
import AtrasanMockup from './images/list/atrasan.webp';
import DrdpMockup from './images/list/drdp.webp';
import NoltoMockup from './images/list/nolto.webp';
import PetEraMockup from './images/list/pet-era.webp';
import HeartShareMockup from './images/list/heart-share.webp';
import KingslandMockup from './images/list/kingsland.webp';
import OcuMockup from './images/list/ocu.webp';
import RingSchoolMockup from './images/list/ring-school.webp';
import UnsaeNowMockup from './images/list/unsae-now.webp';

export type PortfolioListData = {
	title: string;
	description: string;
	link: PortfolioName;
	// type: PortfolioType;
	color: string;
	mockupImage: string;
	isWeb?: boolean; // 웹 프로젝트 여부 (목업 모양이 다름)
};

// 주소 오류 방지하기 위해 아래에 정의하고 사용할것. (detail에서 가져올때도 사용합니다)
export const PORTFOLIO_NAME = {
	PARADISE_BUSAN: 'paradise-busan',
	PARADISE_INCHEON: 'paradise-incheon',
	DEAR_MONDAY: 'dear-monday',
	TTOKTTOK365: 'ttokttok365',
	HYUNDAI: 'hyundai',
	VROONG: 'vroong',
	ARTIKET: 'artiket',
	// ATRASAN: 'atrasan', // 2025.06.09 아트라상 이슈가 있어 주석처리.
	DRDP: 'drdp',
	NOLTO: 'nolto',
	HEART_SHARE: 'heart-share',
	KINGSLAND: 'kingsland',
	OCU: 'ocu',
	PET_ERA: 'pet-era',
	// RING_SCHOOL: 'link-school', // 링스쿨이 link-school로 변경됨. 이슈가 있어 주석처리.
	UNSAE_NOW: 'unsae-now'
} as const;
export type PortfolioName =
	(typeof PORTFOLIO_NAME)[keyof typeof PORTFOLIO_NAME];

export const PORTFOLIO_LIST_DATA: PortfolioListData[] = [
	{
		title: '현대 HMG',
		description:
			'현대 정의선 회장님의 메시지를 사내 임원 및 임직원들이 손쉽게 접근하고 열람할 수 있는 서비스입니다. \n다국어 기능과 트랜스크립트로 누구나 편리하게 메시지 내용을 확인할 수 있습니다.',
		link: PORTFOLIO_NAME.HYUNDAI,
		color: '#101016',
		mockupImage: HyundaiMockup
	},
	// 	{
	// 		title: '링스쿨',
	// 		description: `LG헬로비전의 교육공간혁신 플랫폼 링스쿨은 공간과 디바이스를 원터치로 연결하는 디지털 교육 플랫폼입니다.
	// 블랜디드 러닝 솔루션, 교실환경 제어, 교수학습 시스템 등을 지원합니다.`,
	// 		link: PORTFOLIO_NAME.RING_SCHOOL,
	// 		color: '#450BC1',
	// 		mockupImage: RingSchoolMockup,
	// 		isWeb: true
	// 	},
	{
		title: '파라다이스호텔 부산',
		description:
			'파라다이스호텔 부산 앱은 비대면 체크인/체크아웃 서비스로 더욱 빠르고 \n편리한 투숙 경험을 제공합니다. 모바일 키를 사용해 프론트 데스크를 거치지 않고 \n주차장에서 바로 객실까지 이동할 수 있습니다.',
		link: PORTFOLIO_NAME.PARADISE_BUSAN,
		color: '#9C836A',
		mockupImage: ParadiseBusanMockup
	},
	{
		title: '파라다이스호텔 인천',
		description:
			'파라다이스 앱은 호텔, 엔터테인먼트, 다이닝 등 모든 시설을 원터치로 간편하게 예약할 수 있는 서비스입니다. 모바일 키 서비스를 통해 프론트 데스크를 거치지 않고 주차장에서 바로 객실까지 이동할 수 있어 편리한 투숙 경험을 제공합니다.',
		link: PORTFOLIO_NAME.PARADISE_INCHEON,
		color: '#E9E4D7',
		mockupImage: ParadiseIncheonMockup
	},
	{
		title: '부릉',
		description: `물류의 혁신을 만들어가는 스마트 배송 플랫폼 부릉은
	자체 개발한 물류 첨단 기술과 물류 인프라를 바탕으로
	고객의 유통 물류를 통합하고 디지털화하는 서비스입니다.`,
		link: PORTFOLIO_NAME.VROONG,
		color: '#05CE82',
		mockupImage: VroongMockup
	},
	{
		title: 'OCU',
		description: `OCU는 한국열린사이버대학 학생들의 과제 일정 관리 서비스입니다. 날짜별 과제를 알려주어 학생들이 과제를 잊지 않고 수행할 수 있도록 도와줍니다. `,
		link: PORTFOLIO_NAME.OCU,
		color: '#124480',
		mockupImage: OcuMockup
	},
	{
		title: '똑똑365',
		description:
			'똑똑365는 집 청소부터 정리수납까지, 생활공간의 전반적인 관리 서비스를 제공하는 토탈 홈케어 플랫폼입니다. 사용자는 자신이 중요하게 생각하는 청소 포인트나 생활 패턴에 맞춰 맞춤형 서비스를 신청할 수 있습니다.',
		link: PORTFOLIO_NAME.TTOKTTOK365,
		color: '#FE6F0F',
		mockupImage: Ttokttok365Mockup
	},
	{
		title: '디어먼데이',
		description:
			'디어먼데이는 일과 휴식을 조화롭게 즐길 수 있는 워케이션 플랫폼입니다. 다양한 지역에서 제공되는 프리미엄 워케이션 공간을 통해 일과 휴식을 조화롭게 결합한 새로운 방식의 라이프스타일을 경험할 수 있습니다.',
		link: PORTFOLIO_NAME.DEAR_MONDAY,
		color: '#006868',
		mockupImage: DMMockup
	},
	{
		title: '놀토',
		description: `내 손안의 역사 가이드 놀토는 자녀의 학년에 맞게 전국에 있는 역사 여행지 및 체험을 추천해주는 서비스입니다.
		전국의 500개가 넘는 생생한 현장 콘텐츠로, 현장 방문 시 꼭 봐야 하는 유물,  유적지 등을 눈높이에 맞춰 알려줍니다.`,
		link: PORTFOLIO_NAME.NOLTO,
		color: '#4285F4',
		mockupImage: NoltoMockup
	},
	// 2025.06.09 아트라상 이슈가 있어 주석처리.
	// {
	// 	title: '아트라상',
	// 	description: `아트라상은 재회 상담 및 컨설팅 전문 서비스로, 연인과 재회를 희망하거나, 관계 문제로 고민 중인 분들에게 맞춤형 조언을 제공하며 체계적인 절차와 전문성 높은 상담을 통ㅎ애 사용자의 관계 회복을 돕고 있습니다.`,
	// 	link: PORTFOLIO_NAME.ATRASAN,
	// 	color: '#08A2BB',
	// 	mockupImage: AtrasanMockup
	// },
	{
		title: '아티켓',
		description: `아티켓은 다양한 예술가들이 참여하여 자신의 작품을 소개하고 판매할 수 있는 플랫폼입니다. 사용자는 피드에서 작품을 브라우징하고 원하는 작품을 구매할 수 있습니다.`,
		link: PORTFOLIO_NAME.ARTIKET,
		color: '#8225F9',
		mockupImage: ArtiketMockup
	},

	{
		title: '닥터두피',
		description: `닥터두피는 두피와 모발 관리를 위한 앱 서비스입니다.
	지역 기반 병원 정보, 두피 관련 Q&A, AI기반 두피/모발 분석 기능을 통해 사용자 맞춤형 솔루션을 제공합니다.`,
		link: PORTFOLIO_NAME.DRDP,
		color: '#4285F4',
		mockupImage: DrdpMockup
	},

	{
		title: '반려시대',
		description: `반려시대는 반려견 유치원을 쉽고 빠르게 찾아 예약할 수있는 반려견 유치원 CRM 서비스입니다.
	가까운 반려견 유치원을 소개하고 등록된 유치원에서 반려견의 상태를 실시간으로 관리 및 공유할 수 있습니다.`,
		link: PORTFOLIO_NAME.PET_ERA,
		color: '#FAE100',
		mockupImage: PetEraMockup
	},

	{
		title: '킹스랜드',
		description: `킹스랜드는 호율적인 부동산 거래를 위한 전문 컨설턴트 솔루션 서비스입니다.
			토지 정보를 쉽게 파악할 수 있는 마스터 추천 기능과 토지 전문가의 맞춤형 컨설팅 서비스를 제공합니다.`,
		link: PORTFOLIO_NAME.KINGSLAND,
		color: '#7AC061',
		mockupImage: KingslandMockup
	},
	{
		title: '운세나우',
		description: `운세나우는 운세 상담 전문가와의 화상 상담 서비스입니다.
	비대면 환경에서 타로, 운세, 신점, 심리 상담사와 편리하게 소통할 수 있습니다.`,
		link: PORTFOLIO_NAME.UNSAE_NOW,
		color: '#FFD438',
		mockupImage: UnsaeNowMockup
	},

	{
		title: '하트쉐어',
		description: `하트쉐어는 앱 포인트를 활용한 기부 플랫폼입니다. 사용자는 적립한 포인트로 손쉽게 기부에 참여할 수 있습니다. 기부금 사용 내역을 투명하게 공개해 신뢰성을 제공합니다.`,
		link: PORTFOLIO_NAME.HEART_SHARE,
		color: '#FB881E',
		mockupImage: HeartShareMockup
	}
];
